if (typeof NSSScrollingBar !== "function") {
    var ScrollingText = (function () {
        function getWidth(element) {
            var rect = element.getBoundingClientRect();
            return rect.right - rect.left;
        }

        function ScrollingText(box, speed, toggle) {
            var inner_element = (box.children && box.children[0]) || null;
            if (!inner_element) throw "No child node found";

            inner_element.style.position = "relative";

            this.position = 0;
            this.speed = speed;
            this.toggle =toggle;
            this.box_width = getWidth(box);
            this.inner_element_width = getWidth(inner_element);
            this.box = box;
            this.inner_element = inner_element.cloneNode(true);
            setUpChildrens.call(this);
        }

        function refreshWidths() {
            this.box_width = getWidth(this.box);
            this.inner_element_width = getWidth(this.box.children[0]);
        }

        function calculateNumElements() {
            return Math.ceil(this.box_width / this.inner_element_width) + 1;
        }

        function setUpChildrens() {
            var qty = calculateNumElements.call(this);
            if (qty > this.box.children.length) {
                for (var i = this.box.children.length; i < qty; i++)
                    this.box.appendChild(this.inner_element.cloneNode(true));
            } else if (qty < this.box.children.length) {
                for (var i = qty; i < this.box.children.length; i++)
                    this.box.removeChild(this.box.lastChild);
            }
        }

        function nextFrame(delta, direction) {
            var self = this;
            refreshWidths.call(this);
            setUpChildrens.call(this);
            Array.prototype.forEach.call(this.box.children, function (el) {

                if (direction == "rtl") {
                    el.style.transform = `translateX(${self.position}px)`;
                } else {
                    el.style.transform = `translateX(${-self.position}px)`;
                }
            });
            this.position += (this.speed * delta) / 1000;
            if (this.position >= this.inner_element_width)
                this.position = this.position % this.inner_element_width;
        }

        ScrollingText.prototype = {
            start: function (direction, speed) {
                this._running = true;
                var self = this;
                var last_time = null;
                var loop_func = function () {
                    if (!self._running) return;
                    var now = Date.now();
                    var delta = last_time === null ? 0 : now - last_time;
                    nextFrame.call(self, delta, direction, speed);
                    last_time = now;
                    window.requestAnimationFrame(loop_func);
                };
                window.requestAnimationFrame(loop_func);
                this.toggle?.classList.add('is-plaing');
                this.toggle?.setAttribute('aria-label','Pause');
            },

            stop: function () {
                this._running = false;
                this.toggle?.classList.remove('is-plaing');
                this.toggle?.setAttribute('aria-label','Play');
            },
        };

        return ScrollingText;
    })();
    class NSSScrollingBar extends HTMLElement {
        constructor() {
            super();
            this.sectionMain = this.querySelector('.js-nss-scrolling-bar-wrapper');
            this.toggle = this.querySelector('.js-nss-scrolling-bar-toggle');
            this.speed = window.innerWidth > 768
                ? parseInt(this.dataset.scrollingSpeed)
                : parseInt(this.dataset.scrollingSpeed) / 1.5;
            this.direction = this.dataset.scrollingDirection;
            this.isPlaying = true;

            this.scrollingText = new ScrollingText(this.sectionMain, this.speed, this.toggle);
            this.initEventListeners();
        }

        initEventListeners() {
            if (this.dataset.pauseOnHover === "true") {
                let windowInFocus = true;

                window.addEventListener("blur", () => (windowInFocus = false));
                window.addEventListener("focus", () => (windowInFocus = true));

                this.addEventListener('mouseover', () => windowInFocus && this.scrollingText.stop());
                this.addEventListener('mouseout', () => windowInFocus && this.isPlaying && this.scrollingText.start(this.direction));
            }

            this.toggle?.addEventListener('click', () => this.togglePlayPause());

            new IntersectionObserver(entries => {
                entries[0].isIntersecting ? this.isPlaying && this.scrollingText.start(this.direction) : this.scrollingText.stop();
            }).observe(this);
        }

        togglePlayPause() {
            this.isPlaying = !this.isPlaying;
            this.isPlaying ? this.scrollingText.start(this.direction) : this.scrollingText.stop();
            this.toggle?.classList.toggle('is-plaing', this.isPlaying);
            this.toggle?.setAttribute('aria-label', this.isPlaying ? 'Pause' : 'Play');
        }
    }

    if (typeof customElements.get("nss-scrolling-bar") == "undefined") {
        customElements.define("nss-scrolling-bar", NSSScrollingBar);
    }
}
